export default __webpack_public_path__ + "static/media/vacancy-homecard.0d35c0d2.svg";